module.exports = __webpack_public_path__ + "static/its-better-than-it-looks-2436a2e7a6ae93bda47d68b4959f186e.jpg";